import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submenu", "toggle", "arrow"]

  toggle(event) {
    event.preventDefault()
    const hidden = this.submenuTarget.hidden
    this.submenuTarget.hidden = !hidden
    this.toggleTarget.setAttribute("aria-expanded", String(hidden))
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.toggle("rotate-90", hidden)
    }
  }
}
